export const dlCustomGA4Event = (category, action, label) => {
    window.dataLayer.push({
        customEventGA4Params: null
    });
    window.dataLayer.push({
        event: 'customEventGA4',
        customEventGA4Params: {
            category,
            action,
            label
        }
    });
};
